export enum UploadType {
    Internal = 'TYPE_INTERNAL',
    Supplier = 'TYPE_SUPPLIER',
    Customer = 'TYPE_CUSTOMER',
    PriceMatrix = 'TYPE_PRICE_MATRIX',
}
